import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import api from 'api';

const StatisticsDayOfWeek = () => {
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const days = ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일'];

  // 요일별 매출 데이터 조회
  const fetchDayOfWeekSales = async (start, end) => {
    setLoading(true);
    try {
      const response = await api.get(`/statistics/day-of-week?startDate=${start}&endDate=${end}`);
      // API 응답을 화면에 맞게 변환
      const formattedData = response.map(item => ({
        ...item,
        day: item.dayName,
        dayShort: item.dayName.substring(0, 2),
      }));
      setData(formattedData);
    } catch (error) {
      console.error('요일별 매출 조회 실패:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDayOfWeekSales(startDate, endDate);
  }, [startDate, endDate]);

  useEffect(() => {
    // ApexCharts 초기화
    if (data.length === 0) return;

    // dayOfWeek 순서대로 정렬
    const sortedData = [...data].sort((a, b) => a.dayOfWeek - b.dayOfWeek);

    const options = {
      series: [
        {
          name: '판매액',
          data: sortedData.map(d => Math.floor(d.sales / 100000)), // 단위: 만원
          type: 'column',
        },
        {
          name: '판매량',
          data: sortedData.map(d => d.quantity),
          type: 'line',
        },
      ],
      chart: {
        type: 'line',
        height: 350,
        toolbar: {
          show: true,
        },
      },
      colors: ['#4154f1', '#2eca6a'],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      xaxis: {
        categories: sortedData.map(d => d.dayShort),
      },
      yaxis: [
        {
          title: {
            text: '판매액 (만원)',
          },
        },
        {
          opposite: true,
          title: {
            text: '판매량',
          },
        },
      ],
      tooltip: {
        shared: true,
        intersect: false,
      },
    };

    const chart = new ApexCharts(document.querySelector('#dayOfWeekChart'), options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [data]);

  const handleSearch = () => {
    fetchDayOfWeekSales(startDate, endDate);
  };

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">요일별 매출 현황</h5>

          <div className="row mb-3">
            <div className="col-sm-2">
              <label htmlFor="startDate" className="form-label">
                시작일:
              </label>
              <input
                id="startDate"
                type="date"
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-sm-1" style={{ textAlign: 'center', paddingTop: '35px' }}>
              ~
            </div>
            <div className="col-sm-2">
              <label htmlFor="endDate" className="form-label">
                종료일:
              </label>
              <input
                id="endDate"
                type="date"
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className="col-sm-2" style={{ paddingTop: '35px' }}>
              <button type="button" className="btn btn-primary" onClick={handleSearch}>
                조회
              </button>
            </div>
            <div className="col-sm-5">&nbsp;</div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">로딩 중...</span>
              </div>
            </div>
          ) : (
            <div id="dayOfWeekChart"></div>
          )}

          <table className="table table-striped mt-4">
            <thead>
              <tr>
                <th scope="col">요일</th>
                <th scope="col">판매액</th>
                <th scope="col">판매량</th>
                <th scope="col">판매건수</th>
              </tr>
            </thead>
            <tbody>
              {[...data].sort((a, b) => a.dayOfWeek - b.dayOfWeek).map((item, index) => (
                <tr key={index}>
                  <td>{item.day}</td>
                  <td>¥{item.sales.toLocaleString('ko-KR')}</td>
                  <td>{item.quantity}</td>
                  <td>{item.customers}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StatisticsDayOfWeek;
